import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'antera-lib-kanban-body',
  templateUrl: './kanban-body.component.html',
  styleUrls: ['./kanban-body.component.scss']
})
export class KanbanBodyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
